// extracted by mini-css-extract-plugin
module.exports = {"section":"_3AnDMUs6 dUMdRZQH _3mW2gstu","card":"_2vfQ92jd _32cMlxJ_","input":"Hv5kg_qP","capitalize":"_1vlE5-Qg"};